import { render, staticRenderFns } from "./PrijavaForma.vue?vue&type=template&id=5935fd7b&scoped=true&"
import script from "./PrijavaForma.vue?vue&type=script&lang=js&"
export * from "./PrijavaForma.vue?vue&type=script&lang=js&"
import style1 from "./PrijavaForma.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935fd7b",
  null
  
)

export default component.exports